@use "variables" as *;

.item {
  border-radius: 12px;
}

.container {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
}

.actionArea {
  display: flex;
  flex-grow: 1;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
  width: 100%;
}

.readName {
  font-size: $fontSize-m;
  font-weight: normal;
  text-align: left;
  width: 100%;
}

.visibility {
  font-size: $fontSize-xxs;
  font-weight: normal;
  text-align: right;
  margin: $spacing-s;
}

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
  width: 100%;
  text-align: left;
  vertical-align: top;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.severityMark {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 12px;
}
